import { UPDATE_IMPORTED_PAYMENT_LIST, CLEAR_IMPORTED_PAYMENT_LIST } from './actions';

const importedPaymentList = (state = [], action) => {
	switch (action.type) {
		case UPDATE_IMPORTED_PAYMENT_LIST: {
			return [...action.payments];
		}
		case CLEAR_IMPORTED_PAYMENT_LIST: {
			return [];
		}
		default:
			return state;
	}
};

export default importedPaymentList;
